import { Heading, Icon, Span, type UiIconNames } from "@icg360/design-system";

import { formatCurrency } from "utils";

import styles from "./commercial-coverages.module.scss";

const isNilOrZero = (val) => [null, undefined, "0"].includes(val);

export const CommercialCoverages = ({ data }) => {
  const { currentTerm } = data?.userDetails ?? {
    currentTerm: {},
    additionalAddresses: [],
  };
  const {
    coverageE,
    coverageEPerOccurrence,
    coverageEAggregate,
    coverageF,
    coverageM,
    termLocationData,
  } = currentTerm ?? {};
  let medicalPayments = coverageF;

  if (isNilOrZero(coverageE) && isNilOrZero(coverageF)) {
    medicalPayments = coverageM;
  }

  const locationData = termLocationData?.find((loc) => loc?.location === 1);
  let building = "N/A",
    businessPersonalProperty = "N/A";

  if (locationData) {
    building = locationData?.coverageA ?? "N/A";
    businessPersonalProperty = locationData?.coverageC ?? "N/A";
  }

  const formatLiability = (occ, agg) => (
    <>
      {formatCurrency(occ)} occ / <br />
      {formatCurrency(agg)} agg
    </>
  );

  const coverageValueDisplay = (coverageValue) => {
    return coverageValue && coverageValue !== "0"
      ? formatCurrency(coverageValue)
      : "N/A";
  };

  const coverageMap = [
    {
      icon: "House",
      label: "Building",
      details:
        "Coverage to help repair or rebuild your home if it's damaged or destroyed.",
      value: coverageValueDisplay(building),
    },
    {
      icon: "Fence",
      label: "Business Personal Property",
      details:
        "Coverage for things like sheds, garages, and fences that are not your home.",
      value: coverageValueDisplay(businessPersonalProperty),
    },
    {
      icon: "Computer",
      label: "Liability",
      details:
        "Coverage for your belongings that aren't attached to your home, like furniture and clothing.",
      value: formatLiability(coverageEPerOccurrence, coverageEAggregate),
    },
    {
      icon: "PhysicalInjury",
      label: "Medical expenses",
      details:
        "Coverage for a temporary place to stay and living expenses such as food, if your home is damaged and you can't live there.",
      value: coverageValueDisplay(medicalPayments),
    },
  ];

  const PropertyCoverageDisplay = () => {
    return coverageMap.map(
      (coverage: {
        icon: UiIconNames;
        label: string;
        details: string;
        value: string;
      }) => (
        <div className={styles.coverageItemHeader} key={coverage.label}>
          <div className={styles.coverageIcon}>
            <Icon name={coverage.icon} size="lg" />
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.content}>
              <Heading size="xs">{coverage.label}</Heading>
              <Span color="quiet">{coverage.details}</Span>
            </div>
            <div className={styles.valueDS}>
              <Span bold>{coverage.value}</Span>
            </div>
          </div>
        </div>
      ),
    );
  };

  return <PropertyCoverageDisplay />;
};
